import { render, staticRenderFns } from "./HeaderBannerLogo.vue?vue&type=template&id=e70a349a&scoped=true&"
import script from "./HeaderBannerLogo.vue?vue&type=script&lang=js&"
export * from "./HeaderBannerLogo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBannerLogo.vue?vue&type=style&index=0&id=e70a349a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70a349a",
  null
  
)

export default component.exports